import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { BookingStore } from '@store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserDetails } from '@vi-iot/client';
import { ViLoaderComponent, ViPanelComponent } from '@vi-iot/ui/index';
import { PackagePerInstallationBookingsComponent } from './package-per-installation-bookings/package-per-installation-bookings.component';
import { FlatRateBookingsComponent } from './flat-rate-bookings/flat-rate-bookings.component';
import { BannerComponent } from '@components';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';

@Component({
  selector: 'app-user-booking-list',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    ViPanelComponent,
    ViLoaderComponent,
    PackagePerInstallationBookingsComponent,
    FlatRateBookingsComponent,
    BannerComponent,
  ],
  templateUrl: './user-booking-list.component.html',
  styleUrls: ['./user-booking-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserBookingListComponent implements OnInit, OnDestroy {
  @Input() userDetails: UserDetails;
  isFlatRate: boolean;

  private ngUnsubscribe$: Subject<void> = new Subject();

  constructor(public bookingStore: BookingStore) {}

  ngOnInit(): void {
    const companyId = this.userDetails?.company?.id;
    this.bookingStore.getAllVitoguideSubscriptions(companyId);
    this.bookingStore.getActiveProSubscriptionForFlatRate$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((subscription) => {
        // Async pipe not used due to both truthy and falsy values are expected
        this.isFlatRate = !!subscription;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
